import { useEffect, useRef } from "react";

function useGlobalKeyPress(targetKey, onTrigger) {
  const countRef = useRef(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key !== targetKey) return;

      countRef.current += 1;

      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        countRef.current = 0;
      }, 1000);

      if (countRef.current === 10) {
        countRef.current = 0;
        onTrigger();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      clearTimeout(timerRef.current);
    };
  }, [targetKey, onTrigger]);
}

export default useGlobalKeyPress;
